import { useState } from "react";
import { Link, NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, Camera, Boxes, Truck, ClipboardList, Percent, ShoppingCart, Users, Gamepad2, Send, CreditCard, Calculator, Bot, Newspaper, Megaphone, BarChart3, Bell, Settings, Menu, X, Store, LogOut, KeyRound } from "lucide-react";
import { useAuth } from "../../lib/ctx";
import { Logo } from "../../components/Logo";

export const ADMIN_NAV = [
  ["Overview", "", LayoutDashboard], ["Products", "products", Package], ["AI Product Studio", "studio", Camera], ["Inventory", "inventory", Boxes], ["Suppliers", "suppliers", Truck],
  ["Purchase Orders", "purchase-orders", ClipboardList], ["Pricing", "pricing", Percent, true], ["Orders", "orders", ShoppingCart], ["Customers", "customers", Users],
  ["Game Top-Up", "game-topup", Gamepad2], ["Shipping", "shipping", Send], ["Payments", "payments", CreditCard], ["Accounting", "accounting", Calculator, true],
  ["AI Support", "ai-support", Bot], ["News & SEO", "news", Newspaper], ["Marketing", "marketing", Megaphone], ["Reports", "reports", BarChart3],
  ["Notifications", "notifications", Bell], ["Settings", "settings", Settings, true], ["Change password", "password", KeyRound],
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const go = useNavigate();
  if (loading || user === null) return <p className="p-20 text-center text-zinc-500">Loading…</p>;
  if (!user) return <Navigate to="/login" replace />;
  if (!["admin", "staff"].includes(user.role)) return <Navigate to="/account" replace />;
  const nav = ADMIN_NAV.filter((n) => !n[3] || user.role === "admin");
  return (
    <div className="shopee min-h-screen bg-[#f5f5f5] lg:flex" data-testid="admin-layout">
      <div className="sp-header keep-orange flex items-center justify-between p-4 text-white lg:hidden">
        <Logo compact /><button onClick={() => setOpen(!open)} data-testid="admin-menu-btn">{open ? <X /> : <Menu />}</button>
      </div>
      <aside className={`${open ? "block" : "hidden"} w-full shrink-0 border-r border-[#eee] bg-white shadow-[1px_0_4px_rgba(0,0,0,.04)] lg:sticky lg:top-0 lg:block lg:h-screen lg:w-64 lg:overflow-y-auto`}>
        <div className="hidden p-6 lg:block"><Logo /></div>
        <p className="px-6 pb-2 font-mono text-[10px] uppercase tracking-widest text-[#C8A45D]">{user.role} · {user.email}</p>
        <nav className="space-y-0.5 px-3 pb-6">
          {nav.map(([label, to, Icon]) => (
            <NavLink key={label} to={`/admin${to ? `/${to}` : ""}`} end={!to} onClick={() => setOpen(false)} data-testid={`admin-nav-${to || "overview"}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 text-sm transition-colors duration-200 rounded-sm ${isActive ? "bg-[#ee4d2d] font-semibold text-white" : "text-[#333] hover:bg-[#fff1ee] hover:text-[#ee4d2d]"}`}>
              <Icon className="h-4 w-4" />{label}
            </NavLink>
          ))}
          <Link to="/" className="mt-4 flex items-center gap-3 px-3 py-2 text-sm text-zinc-500 hover:text-white" data-testid="admin-view-store"><Store className="h-4 w-4" />View store</Link>
          <button onClick={async () => { await logout(); go("/login"); }} className="flex w-full items-center gap-3 px-3 py-2 text-sm text-red-400 transition-colors duration-200 hover:bg-white/5" data-testid="admin-logout-btn"><LogOut className="h-4 w-4" />Log out</button>
        </nav>
      </aside>
      <div className="min-w-0 flex-1">
        <div className="sp-header keep-orange hidden items-center justify-between px-8 py-3 text-white lg:flex" data-testid="admin-topbar">
          <p className="text-lg font-extrabold tracking-tight">Seller Centre</p>
          <div className="flex items-center gap-5 text-sm"><Link to="/" className="flex items-center gap-1.5 hover:opacity-80" data-testid="admin-topbar-store"><Store className="h-4 w-4" />View store</Link><span className="opacity-90">{user.name || user.email}</span></div>
        </div>
        <main className="min-w-0 p-4 sm:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
